import { timerFormatter } from "./helper/timeFormatter";
import HELPERS from "../lib/globals/helpers/Helpers";
import { EVENTS } from "../lib/constants";
import { GameConfigs } from "../lib/globals/GameConfigs";
import { NotificationView } from "../view/notifications/NotificationView";

let interval;
class TimerController {
  constructor(seconds) {
    this.seconds = seconds;
    this.quest_claim = {
      claimed: false,
      activated: false,
      activated_item: 0,
      quest_data: null,
      step: false,
      status: "",
      leftBets: null,
    };
  }

  updateTimer(time) {
    clearInterval(interval);
    let counter = 0;
    interval = setInterval(() => {
      const isModal =
        GameConfigs.modal === "quest" ||
        GameConfigs.modal === "quest_claim" ||
        GameConfigs.modal === "prompt" ||
        GameConfigs.modal === "quest_prompt";

      if (time - counter > 0) {
        counter++;
        HELPERS.dispatchCustomEvent(EVENTS.QUEST_UPDATE, {
          time: time - counter,
          formated: timerFormatter(time - counter),
        });
        GameConfigs.time_left = timerFormatter(time - counter);
      } else {
        if (!GameConfigs.bonusBuy) {
          window.connectionProvider.getQuest(
            JSON.stringify({
              service: "quest",
              data: {},
            })
          );
          HELPERS.dispatchCustomEvent(EVENTS.QUEST_CLAIM, {
            quest_claim: this.quest_claim,
          });
          GameConfigs.quest_claim = this.quest_claim;
          GameConfigs.quest_current = null;
          GameConfigs.quest_is_active = false;
          HELPERS.dispatchCustomEvent(EVENTS.QUEST_END, {
            end: true,
          });
		  
          if (isModal) {
            GameConfigs.modal = "notification";
            GameConfigs.notification = {
              code: 1112,
              msg: "",
              status: "",
            };
            HELPERS.dispatchCustomEvent(EVENTS.MODAL, {
              modal: "notification",
            });
            GameConfigs.uiComponent.addView(NotificationView);
          }
          GameConfigs.updateQuest = true;
          clearInterval(interval);
        }
      }
    }, 1000);
  }
}

export default TimerController;
